export const shows = [{ key: "name" }, { key: "owner" }, { key: "status" }];
export const teasers = [{ key: "title" }, { key: "owner" }, { key: "status" }];
export const showMains = [
  { key: "title" },
  { key: "owner" },
  { key: "status" },
];
export const showSettings = [
  { key: "name" },
  { key: "slug" },
  { key: "owner" },
  { key: "status" },
];

export const pages = [
  { key: "root" },
  { key: "slug" },
  { key: "title" },
  { key: "discription" },
  { key: "owner" },
  { key: "status" },
];

export const topPages = [
  { key: "title" },
  { key: "discription" },
  { key: "owner" },
];

export const showBooths = [
  { key: "id", defaultSort: "asc" },
  { key: "name" },
  { key: "priority" },
  { key: "owner" },
  { key: "status" },
];
export const showBoothItems = [
  { key: "id", defaultSort: "asc" },
  { key: "name" },
  { key: "priority" },
  { key: "productUrl" },
  { key: "owner" },
  { key: "status" },
];

export const images = [
  { key: "url", img: true },
  { key: "alternate" },
  { key: "owner" },
  { key: "updatedAt", defaultSort: "desc" },
];

export const boothBoatTypes = [
  { key: "name", defaultSort: "asc" },
  { key: "priority" },
];

export const boothBoatBrands = [
  { key: "name", defaultSort: "asc" },
  { key: "priority" },
];
